import { render, staticRenderFns } from "./GradientBtn.vue?vue&type=template&id=35b3facc&scoped=true"
import script from "./GradientBtn.vue?vue&type=script&lang=js"
export * from "./GradientBtn.vue?vue&type=script&lang=js"
import style0 from "./GradientBtn.vue?vue&type=style&index=0&id=35b3facc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b3facc",
  null
  
)

export default component.exports